import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import ProjectsHeader from './components/ProjectsHeader';
import ProjectsPage from './components/ProjectsPage';
import ProjectForm from './components/ProjectsPage/components/ProjectForm';
import styles from './styles';
import { drawerTypes } from '../Equipment/components/helpers/drawerTypes';
import { useDispatch } from 'react-redux';
import { getLocations } from 'store/settings/settingsOperations';
import InfoDialog from 'components/InfoDialog/InfoDialog';
import { useBootstrapLaborClassifications } from 'store/laborClassifications';

const Projects = ({ classes, openSnackbar }) => {
  const dispatch = useDispatch();
  useBootstrapLaborClassifications();
  const [drawer, setDrawer] = useState({
    type: drawerTypes.create,
    isOpen: false,
  });
  const [displayContractorLocationAdded, setDisplayContractorLocationAdded] = useState({ isOpen: false });

  const openDrawer = (type, open) => () => {
    setDrawer({ type, isOpen: open });
  };

  const closeDrawer = () => {
    setDrawer((prev) => ({ ...prev.drawer, isOpen: false }));
  };

  useEffect(() => {
    dispatch(getLocations());
  }, [])


  const getDisplayContractorAddedLocationsMessage = () => {
    if (!displayContractorLocationAdded?.locations?.length || !displayContractorLocationAdded?.project) {
      return '';
    }

    const contractor = displayContractorLocationAdded.project?.contractor;
    return `Contractor ${contractor?.name} was not found in the following locations: ${displayContractorLocationAdded.locations?.join(', ')}. The contractor has been added automatically.`
  }

  return (
    <div className={classes.root}>
      <ProjectsHeader openDrawer={openDrawer} type={'Projects'} />

      <ProjectsPage
        openSnackbar={openSnackbar}
        classes={classes}
        setDisplayContractorLocationAdded={setDisplayContractorLocationAdded}
      />
      <Drawer
        anchor="right"
        open={drawer.isOpen}
        classes={{
          paper: classes.drawer,
        }}
      >
        <ProjectForm
          closeDrawer={closeDrawer}
          openSnackbar={openSnackbar}
          type={drawer.type}
          setDisplayContractorLocationAdded={setDisplayContractorLocationAdded}
        />
      </Drawer>

      {(displayContractorLocationAdded?.isOpen) ? (
        <InfoDialog
          isOpen={displayContractorLocationAdded?.isOpen}
          onClose={() => setDisplayContractorLocationAdded({ isOpen: false })}
          title="Contractor Added to Location(s)"
          message={getDisplayContractorAddedLocationsMessage()}
          btnText="Done"
        />
      ) : null}
    </div>
  );
};

Projects.propTypes = {
  classes: propTypes.object.isRequired,
  openSnackbar: propTypes.func.isRequired,
};

export default withStyles(styles)(Projects);
